import _get from "lodash/get";
import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'formik';
import { ThemeContext } from 'styled-components';
import withSizes from 'react-sizes';
import { ContentRenderer, helpersPropTypes } from '~helpers';
import { LeftAsideTemplate } from '~template';
import { HeroCarousel } from '~hero-carousel';
import { H1, H2, H3, ULGrid } from '~typography';
import { Row, Col, isSizes } from '~layout';
import FormikWrapper from '../ProductCheckout/FormikWrapper';
import RibbonCheckout from '../RibbonCheckout';
import ProductDetails from '../ProductDetails';
import ProductCard from '../ProductCard';
import SizeChart from '../SizeChart';
import Description from './Description';
import commerceTheme from '../../styles/commerceTheme';
import commercePropTypes from '../../prop-types/commercePropTypes';

var ProductTemplate = function ProductTemplate(_ref) {
  var footer = _ref.footer,
      product = _ref.product,
      backgroundColor = _ref.backgroundColor,
      isMobile = _ref.isMobile;
  var theme = useContext(ThemeContext);

  var _useState = useState(false),
      checkIsMobile = _useState[0],
      setIsMobile = _useState[1];

  useEffect(function () {
    setIsMobile(isMobile);
  }, [isMobile]);

  var bgStart = _get(theme, 'commerce.productTemplate.bgStart', commerceTheme.commerce.productTemplate.bgStart);

  var bgEnd = _get(theme, 'commerce.productTemplate.bgEnd', commerceTheme.commerce.productTemplate.bgEnd);

  var title = product.title,
      subtitle = product.subtitle,
      price = product.price,
      description = product.description,
      currency = product.currency,
      discount = product.discount,
      availableStyles = product.availableStyles,
      onProductChange = product.onProductChange,
      onProductSubmit = product.onProductSubmit,
      imageDetails = product.imageDetails,
      imageSet = product.imageSet,
      productDetails = product.productDetails,
      productSizeChart = product.productSizeChart,
      productCare = product.productCare;
  var productDetailsTitle = productDetails.title,
      productDetailsContent = productDetails.content;
  var productSizeChartTitle = productSizeChart.title,
      productSizeChartContent = productSizeChart.content;
  var productCareTitle = productCare.title,
      productCareContent = productCare.content;

  var renderBannerCarousel = function renderBannerCarousel(isSubmitting) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroCarousel, {
      carouselImageSet: imageSet,
      showDivider: true,
      backgroundColor: backgroundColor
    }), /*#__PURE__*/React.createElement(RibbonCheckout, {
      price: price,
      currency: currency,
      discount: discount,
      availableStyles: availableStyles,
      onProductChange: onProductChange,
      onProductSubmit: onProductSubmit,
      isSubmitting: isSubmitting,
      backgroundColor: backgroundColor,
      index: 0
    }));
  };

  var renderAside = function renderAside(isSubmitting) {
    return /*#__PURE__*/React.createElement(Row, {
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(Col, {
      xxs: 28,
      md: 26,
      lg: 28
    }, /*#__PURE__*/React.createElement(ProductCard, {
      title: title,
      subtitle: subtitle,
      imageDetails: imageDetails,
      price: price,
      currency: currency,
      discount: discount,
      availableStyles: availableStyles,
      onProductChange: onProductChange,
      onProductSubmit: onProductSubmit,
      index: 1,
      isSubmitting: isSubmitting
    })));
  };

  var renderMain = /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Col, {
    xxs: 28,
    md: 26,
    lg: 28
  }, /*#__PURE__*/React.createElement(Description, null, checkIsMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H1, null, title), /*#__PURE__*/React.createElement(H2, null, subtitle)), /*#__PURE__*/React.createElement(H3, null, description)), /*#__PURE__*/React.createElement(ProductDetails, {
    title: productDetailsTitle
  }, /*#__PURE__*/React.createElement(ULGrid, {
    list: productDetailsContent,
    rowAmount: 3
  })), /*#__PURE__*/React.createElement(ProductDetails, {
    title: productSizeChartTitle
  }, /*#__PURE__*/React.createElement(SizeChart, {
    sizeChart: productSizeChartContent
  })), /*#__PURE__*/React.createElement(ProductDetails, {
    title: productCareTitle
  }, /*#__PURE__*/React.createElement(ContentRenderer, {
    source: productCareContent
  }))));
  return /*#__PURE__*/React.createElement(FormikWrapper, {
    onProductSubmit: onProductSubmit,
    availableStyles: availableStyles
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true
    }, /*#__PURE__*/React.createElement(LeftAsideTemplate, {
      bgStart: bgStart,
      bgEnd: bgEnd,
      banner: renderBannerCarousel(isSubmitting),
      aside: renderAside(isSubmitting),
      main: renderMain,
      footer: footer
    }));
  });
};

ProductTemplate.defaultProps = {
  footer: undefined,
  isMobile: false
};

var mapSizesToProps = function mapSizesToProps(_ref3, _ref4) {
  var width = _ref3.width;
  var theme = _ref4.theme;
  return {
    isMobile: isSizes.mdView({
      width: width
    }, {
      theme: theme
    })
  };
};

export default withSizes(mapSizesToProps)(ProductTemplate);